import Component from '@glimmer/component'
import CellTooltip from 'teacher-ui-client/components/stable-table/cell-tooltip'
import { formatValue } from 'teacher-ui-client/utils/format-value'
import {
  getCellValue,
  getCellFormatConfig,
  type CustomCellSignature,
} from 'teacher-ui-client/components/stable-table/basic-table/cell'

export default class TooltipCell extends Component<CustomCellSignature> {
  get value() {
    return getCellValue(this.args.tableMeta)
  }

  get formatEmptyConfig() {
    return getCellFormatConfig(this.args.tableMeta)
  }

  get formattedValue() {
    return formatValue(this.value, this.formatEmptyConfig)
  }

  get cell() {
    return this.args.tableMeta.cellObject
  }

  <template>
    <span data-test-cell-tooltip ...attributes>
      <span>{{this.formattedValue}}</span>
      <CellTooltip data-test-tooltip @text={{this.cell.tooltipValue}} />
    </span>
  </template>
}
